module.exports = __webpack_public_path__ + "static/media/app_store_badge_ru_color_40.d3cd99ee.svg";